// libraries
import type { IVehicle, OfferType } from '@makemydeal/dr-platform-types';
import type { ProgramQuote } from '@makemydeal/dr-dash-types';

// types
import type {
    FirstPencilIncentiveOverride,
    FirstPencilIncentiveSelection,
    FirstPencilManualIncentive,
    FirstPencilProgramsOfferType,
    FirstPencilProgramsTabLeft,
    FirstPencilSetupMode
} from '../types/firstPencilTypes';

// consts/enums
import {
    FIRST_PENCIL_APPLY_FAILED,
    FIRST_PENCIL_APPLY_SUCCEEDED,
    FIRST_PENCIL_CANCELLED,
    FIRST_PENCIL_PROGRAMS_BACK,
    FIRST_PENCIL_CREATE_CONFIRMED,
    FIRST_PENCIL_INCENTIVE_OVERRIDDEN,
    FIRST_PENCIL_INCENTIVES_SELECTED,
    FIRST_PENCIL_INTERCEPT_OPENED,
    FIRST_PENCIL_MANUAL_INCENTIVE_ADDED,
    FIRST_PENCIL_MANUAL_INCENTIVE_UPDATED,
    FIRST_PENCIL_OFFER_TYPE_SWITCHED,
    FIRST_PENCIL_PROGRAM_CLEARED,
    FIRST_PENCIL_PROGRAM_SELECTED,
    FIRST_PENCIL_SETUP_MODE_SELECTED,
    FIRST_PENCIL_TEMPLATE_SELECTED,
    FIRST_PENCIL_VEHICLE_SELECTED
} from '../actionTypes/firstPencilActionTypes';

export const interceptOpened = () => ({ type: FIRST_PENCIL_INTERCEPT_OPENED });

export const setupModeSelected = (setupMode: FirstPencilSetupMode) => ({
    type: FIRST_PENCIL_SETUP_MODE_SELECTED,
    payload: { setupMode }
});

export const templateSelected = (templateId: string, templateName: string) => ({
    type: FIRST_PENCIL_TEMPLATE_SELECTED,
    payload: { templateId, templateName }
});

export const vehicleSelected = (vehicle: IVehicle) => ({
    type: FIRST_PENCIL_VEHICLE_SELECTED,
    payload: { vehicle }
});

export const programSelected = (program: ProgramQuote & { key?: string; creditScoreOverride?: number }, offerType: OfferType) => ({
    type: FIRST_PENCIL_PROGRAM_SELECTED,
    payload: { program, offerType }
});

export const programCleared = () => ({ type: FIRST_PENCIL_PROGRAM_CLEARED });

export const offerTypeSwitched = (offerType: FirstPencilProgramsOfferType, tabLeft?: FirstPencilProgramsTabLeft) => ({
    type: FIRST_PENCIL_OFFER_TYPE_SWITCHED,
    payload: { offerType, ...(tabLeft && { tabLeft }) }
});

export const manualIncentiveAdded = (incentive: FirstPencilManualIncentive) => ({
    type: FIRST_PENCIL_MANUAL_INCENTIVE_ADDED,
    payload: incentive
});

export const manualIncentiveUpdated = (editId: string, changes: Partial<Omit<FirstPencilManualIncentive, 'editId'>>) => ({
    type: FIRST_PENCIL_MANUAL_INCENTIVE_UPDATED,
    payload: { editId, changes }
});

export const incentivesSelected = (selection: FirstPencilIncentiveSelection) => ({
    type: FIRST_PENCIL_INCENTIVES_SELECTED,
    payload: selection
});

export const incentiveOverridden = (override: FirstPencilIncentiveOverride) => ({
    type: FIRST_PENCIL_INCENTIVE_OVERRIDDEN,
    payload: override
});

export const createConfirmed = () => ({ type: FIRST_PENCIL_CREATE_CONFIRMED });

export const cancelled = () => ({ type: FIRST_PENCIL_CANCELLED });

export const programsBack = () => ({ type: FIRST_PENCIL_PROGRAMS_BACK });

export const applySucceeded = () => ({ type: FIRST_PENCIL_APPLY_SUCCEEDED });

export const applyFailed = () => ({ type: FIRST_PENCIL_APPLY_FAILED });
